enum ViewMode {
  Room,
  ScreenShare
}

export default ViewMode;
